import UserInfo from "../common/UserInfo";
import { useState, useEffect } from "react";
import { User } from "../common/types";
import { useGetUserById } from "../common/api";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Button } from "react-bootstrap";
import { useV2UpdateUserMutation } from "@generated";
import { formatUser } from "../common/api/helpers";
import { handleAlert } from "@utils/helperFunctions";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";

const Edit = ({ account, teams, roles, editor }) => {
  const url = window.location.href;
  const id = url.split("/").slice(-1)[0];
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [showSuccessAlert, setShowSuccessAlert] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showFailAlert, setShowFailAlert] = useState<boolean>(false);
  const [updating, setUpdating] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("userInfo");
  const [user, setUser] = useState<User>({
    id: 0,
    name: "",
    title: "",
    email: "",
    phone: "",
    teams: [],
    roles: [],
    userType: "",
    sales: false,
    presales: false,
  });

  const { data, isLoading, isFetching, refetch } = useGetUserById(id);
  const [update] = useV2UpdateUserMutation();

  useEffect(() => {
    if (data && !isLoading && !isFetching) {
      setUser(data);
    }
  }, [isLoading, isFetching]);

  const handleSave = () => {
    const data = formatUser(user, account?.data?.attributes?.["account-id"]);
    update({ id: String(user.id), body: { data } })
      .unwrap()
      .then((res) => {
        setSuccessMessage("User updated");
        setShowSuccessAlert(true);
      })
      .catch((err) => {
        const error = err?.data?.errors?.[0];
        setErrorMessage(
          error?.meta?.exception ||
            error?.detail ||
            "Something went wrong updating this user"
        );
        setShowFailAlert(true);
      })
      .finally(() => {
        setUpdating(false);
        refetch();
      });
  };

  const isArchived = (data && !data.active) || false;

  return (
    <div className="userForm legacyPageBleed">
      {handleAlert(
        showSuccessAlert,
        successMessage,
        setShowSuccessAlert,
        "success",
        ToastAlert
      )}
      {handleAlert(
        showFailAlert,
        errorMessage,
        setShowFailAlert,
        "warning",
        ToastAlert
      )}
      <div className="headerContainer">
        <div className="headerText">
          <Button
            className="ssButtonBgWhite"
            onClick={() =>
              window.location.replace(url.split("/").slice(0, -2).join("/"))
            }
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
          Edit {user?.name || "User"}
        </div>
        <div className="actionBtns">
          {activeTab === "userInfo" && (
            <Button
              className="squareGreenButton"
              disabled={!user.name || !user.email || isArchived}
              onClick={() => {
                if (!user.roles?.length) {
                  setErrorMessage("Please select a user role");
                  setShowFailAlert(true);
                  return;
                }
                setUpdating(true);
                handleSave();
              }}
            >
              Save
            </Button>
          )}
        </div>
      </div>
      {isLoading || isFetching || updating ? (
        <ScopeStackSpinner />
      ) : (
        <UserInfo
          user={user}
          setUser={setUser}
          teams={teams}
          roles={roles}
          account={account}
          isArchived={isArchived}
          editor={editor}
          onTabChange={setActiveTab}
        />
      )}
    </div>
  );
};

export default Edit;
